import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { FC, Suspense, useState } from 'react';
import { ReportSubtype } from '../../../models/Report';
import ReportHubViewExampleModal from '../../ReportHub/ReportHubModals/ViewExample/ReportHubViewExampleModal';
import { ThreeDotLoader } from '../../Fallback/ThreeDotsLoader';
import ProgressDetailedSkillReportContainer from './ProgressDetailedSkillReportContainer';
import { AllDropdowns } from '../../ReportHub/ReportHubModals/GenerateReport/ReportHubModal';
import { Class } from '../../../models/Class';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  setDownloadModalVisible: (visible: boolean) => void;
  downloadModalVisible: boolean;
  allDropdowns: AllDropdowns;
  setAllDropdowns: (allDropdowns: AllDropdowns) => void;
  allClassesData: Class[];
}

const ProgressDetailedSkillReportInfoModal: FC<Props> = ({
  visible,
  setVisible,
  setDownloadModalVisible,
  downloadModalVisible,
  allDropdowns,
  setAllDropdowns,
  allClassesData,
}) => {
  const [checked, setChecked] = useState(false);
  const [exampleModalVisible, setExampleModalVisible] = useState(false);

  const handleContinue = () => {
    sessionStorage.setItem('not_show_again_detailed_skill_report_info', checked.toString());
    setDownloadModalVisible(true);
    setVisible(false);
  };

  const dialogHeader = <h3 className="md:text-lg text-base">Download Detailed Skill Report</h3>;
  const dialogFooter = (
    <>
      <Button label="Cancel" className="p-button-text" onClick={() => setVisible(false)} rounded link />
      <Button label="Continue" onClick={handleContinue} />
    </>
  );
  return (
    <>
      <Dialog
        header={dialogHeader}
        visible={visible}
        style={{ width: '35vw', height: '40vh' }}
        breakpoints={{ '960px': '70vw', '768px': '100vw' }}
        modal
        onHide={() => setVisible(false)}
        footer={dialogFooter}
      >
        <div className="flex flex-column gap-3">
          <p className="text-base" style={{ fontFamily: 'Poppins' }}>
            This report shows individual student performance on each skill for the selected Roadmap, organized by unit
            or standard. It also summarizes class-wide performance, allowing you to seamlessly zoom in and out to focus
            on student, class, or unit/standard-level details.
          </p>
          <div>
            <Button label="View Example" rounded link onClick={() => setExampleModalVisible(true)} />
          </div>
          <div className="flex align-items-center">
            <Checkbox inputId="showAgain" onChange={e => setChecked(e.checked || false)} checked={checked} />
            <label htmlFor="showAgain" className="ml-2">
              Don’t show this again
            </label>
          </div>
        </div>
      </Dialog>
      {downloadModalVisible && (
        <ProgressDetailedSkillReportContainer
          visible={downloadModalVisible}
          setVisible={setDownloadModalVisible}
          allClassesData={allClassesData}
          allDropdowns={allDropdowns}
          setAllDropdowns={setAllDropdowns}
        />
      )}
      {exampleModalVisible && (
        <Suspense fallback={<ThreeDotLoader />}>
          <ReportHubViewExampleModal
            visible={exampleModalVisible}
            setVisible={setExampleModalVisible}
            selectedReportSubtype={ReportSubtype.PROGRESS_DETAILED_SKILL_REPORT}
          />
        </Suspense>
      )}
    </>
  );
};

export default ProgressDetailedSkillReportInfoModal;
